/** Created by azhou on 2019/3/27.*/
<template> 
    <div class="border rounded p-3 pb-0 d-center-between flex-wrap">
      <left-text-border class="w-45 mb-3" leftText="订单号" v-model="orderNum"  @enter="searchSubmit"/>
      <left-text-border class="w-45 mb-3" leftText="团号" v-model="title" v-show="orderType===3" @enter="searchSubmit"/>
      <left-text-autocomplete  class="w-45 mb-3" leftText="酒店名称" :placeholder="false" v-model="name" @enter="searchSubmit" :storeType="3" :adminsearch="true" v-if="isAdmin"/>
      <left-text-border class="w-45 mb-3" v-show="orderType!==1 && orderType!==7 &&userInfo.type!==3"  :leftText="`${storeType.cn}名称`" v-model="name" @enter="searchSubmit" v-else/>
      <left-text-border class="w-45 mb-3" v-show="orderType===7 "  leftText="度假产品名称" v-model="title" @enter="searchSubmit"/>
      <left-text-border class="w-45 mb-3" leftText="购买人手机号" v-model="buyermobile" v-if="orderType === 7" @enter="searchSubmit"/>
      <left-text-autocomplete  class="w-45 mb-3" leftText="采购商名称" :placeholder="false" v-model="company" @enter="searchSubmit" :storeType="2" :adminsearch="true" v-if="isAdmin"/>
      <left-text-border class="w-45 mb-3" leftText="采购商名称" v-model="company" v-else-if="userInfo.type!==2 && orderType !== 7" @enter="searchSubmit"/>
      <left-text-select class="w-45 mb-3" :leftText="userInfo.type==2?'支付酒店':'收款状态'" :options=" userInfo.type==3?paymentStatusHotel:paymentStatus" v-model="pay_flag"  @input="searchSubmit" v-if="!confSlip" />
      <left-text-border class="w-45 mb-3" leftText="门店名称" v-model="company" v-if="orderType === 7" @enter="searchSubmit"/>
      <div class="w-45 mb-3 d-center-start" v-if="$GFUN.isInArray([3,5,6,7,8],orderType)&&!confSlip">
        <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width: 260px;">
          <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
        </el-select>
        <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                end-placeholder="结束时间" />
        <el-date-picker type="dates" v-model="timetime" class="w-100" size="small" 
                        v-show="timeType === 'timeArr'" placeholder="可选择一个或多个日期" />
      </div>
      <div class="w-45 mb-3 d-center-start" v-if="$GFUN.isInArray([1],orderType)">
        <left-text :leftText="storeType.left"/>
        <el-date-picker v-model="timestamp" size="small" type="daterange" class="w-100" range-separator="至" 
          value-format="timestamp" :start-placeholder="storeType.start" :end-placeholder="storeType.end" />
      </div>
      <left-text-select class="w-45 mb-3 " leftText="订单收款" :options="paymentMode " v-model="broker"  @input="searchSubmit" v-show="userInfo.type!=3&&!confSlip"/>
      <div class="w-45 text-right ml-auto mb-3">
        <el-button type="primary" size="small" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'SearchCon',
    props:{
      orderType:{},
      //是否是确认单标识
      confSlip:{
        type:Boolean,
        default:false
      }
    },
    created() {
      if(this.$route.query.pay_flag){
         this.pay_flag=this.$route.query.pay_flag
      }
    },
    computed: {
      ...mapGetters(['storeInfo','userInfo','isAdmin']),
      orderStatus() { return this.$route.query.orderStatus },
      storeType() {
        switch (this.orderType) {
          case 3:return {cn:'酒店',left:'入住日期',start:'入住日期',end:'离店日期'}
          case 5:return {cn:'民宿',left:'入住日期',start:'入住日期',end:'离店日期'}
          case 6:return {cn:'景区',left:'出行时间',start:'开始日期',end:'结束日期'}
          case 7:return {cn:'度假产品',left:'出行时间',start:'开始日期',end:'结束日期'}
          case 8:return {cn:'品牌馆',left:'出行时间',start:'开始日期',end:'结束日期'}
          case 1:return {cn:'门店',left:'购买时间',start:'开始日期',end:'结束日期'}
          default:return {cn:'门店'}
        }
      },
      timeChoose() {
        let string = this.$GFUN.isInArray([6,8],this.orderType) ? '出行' : '入住';
        let arr =  [
          {name:`按${string}时间段`,value:'timeFrame'},
          {name:`按入住日`,value:'timeArr'},
        ];
         arr.push({name:`按发单时间`,value:'postTime'},{name:`按成交时间`,value:'dealTime'},)
        return arr
      }
    },
    data() {
      return {
        timestamp: [],
        timetime:[],
        orderNum:'',
        title:'',
        name:'',
        company:'',
        buyermobile: '',
        timeType:'timeFrame',
        pay_flagList:[
            {name: '全部', id: ''},
            {name: '已支付', id: '1'},
            {name: '未支付', id: '2'},
        ],
        paymentStatus:[
          {name: '全部', id: ''}, 
          {name: '未支付', id: '2'},
          {name: '已支付', id: '1'},
        ],
        paymentStatusHotel:[
            {name: '全部', id: ''}, 
            {name: '未收款', id: '2'},
            {name: '已收款', id: '1'},
        ],
        paymentMode:[
            {name: '全部', id: ''}, 
            {name: '代订收款', id: '1'},
        ],
        broker:'',
        pay_flag:'',
      }
    },
    watch: {
      'orderType':'initSearchCon',
      'orderStatus':'initSearchCon',
    },
    methods:{
      //清空搜索条件
      initSearchCon() {
        this.timestamp = [];
        this.orderNum = '';
        this.title = '';
        this.name = '';
        this.company = '';
        this.buyermobile = '';
        this.pay_flag='';
        this.broker='';
        if (this.orderType === 1) this.timeType = 'timeFrame';
        else this.timeType = 'timeFrame';
      },
      //提交搜索条件
      searchSubmit() {
        let data = {
          oid:this.orderNum,
          title:this.title,
          hotel_title:this.name,
          travel_title:this.company,
          broker:this.broker,
          pay_flag:this.pay_flag,
          // occupant_mobile: this.buyermobile
        }
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
            let timeArr = this.timetime ? this.timetime.map(v => {return ((v.getTime() / 1000) + (this.$GFUN.isInArray([7,8],this.orderType) ? 28800 : 0))}) : [];
            data.date_in = timeArr.join(',');
            break;
          case 'timeFrame':
            data.date_in = start;
            data.date_out = end;
            break;
          case 'postTime':data.add_time = start + ',' + end; break;
          case 'dealTime':data.deal_time = start + ',' + end; break;
        }
        this.$emit('getSearchCon',data);
      }
    }
  }
</script>
